<template>
  <div class="emd-interactive-list eu-mb_3">
    <div class="emd-interactive-list__search" v-if="showSearch()">
      <div class="emd-input-group">
        <input class="emd-input" type="text" :placeholder="$t('search')" v-model="identifier" v-on:input="searchProdAccount(identifier)">
        <i class="uil uil-search"></i>
      </div>
    </div>
    <div class="emd-interactive-list__main">
      <p class="emd-text" v-if="!loadingList && !prodAccounts.items.length">{{$t('no-results')}}</p>
      <div class="emd-loader _invert eu-align_center eu-pa_3" v-if="loadingList">
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class="emd-select-list" v-else>
        <ul>
          <li class="emd-select-list__item" v-for="(acc, index) in prodAccounts.items" :key="index" v-bind:class="{'_active': acc.id === account.id || acc.id === account.master_account_id}" v-on:click="goToAccount(acc.id)">
            <span class="emd-select-list__label">
              <span class="emd-status-tag" :class="acc.status == 'inactive' ? '_color_danger' : '_color_success'" v-bind:title="$t(`status.${acc.status}`)">
                <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" >
                    <path fill="currentColor" d="M8,0 C3.58064516,0 0,3.58064516 0,8 C0,12.4193548 3.58064516,16 8,16 C12.4193548,16 16,12.4193548 16,8 C16,3.58064516 12.4193548,0 8,0 Z"></path>
                </svg>
              </span>
              {{acc.name}}
            </span>
            <span class="emd-select-list__select-icon" v-if="acc.id === account.id">
              <span class="emd-status-tag">
                <i class="uil uil-check-circle"></i>
              </span>
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="emd-interactive-list__pagination" v-if="!loadingList && prodAccounts.pagination.total_page > 1">
      <button class="emd-btn _type_text _size_small" v-bind:class="{'_disabled': prodAccounts.pagination.current_page === 1}" v-on:click.stop="goToPage(page-1)" :disabled="prodAccounts.pagination.current_page === 1">
        {{$t('pagination.previous')}}
      </button>
      <span class="emd-text _size_tiny _align_center">
        {{prodAccounts.pagination.current_page}} {{$t('pagination.of')}} {{prodAccounts.pagination.total_page}}
      </span>
      <button class="emd-btn _type_text _size_small" v-bind:class="{'_disabled': prodAccounts.pagination.current_page === prodAccounts.pagination.total_page}" v-on:click.stop="goToPage(page+1)" :disabled="prodAccounts.pagination.current_page === prodAccounts.pagination.total_page">
        {{$t('pagination.next')}}
      </button>
    </div>
  </div>
</template>

<i18n>
{
  "pt-BR": {
    "search": "Buscar...",
    "no-results": "Não foram encontrados resultados.",
    "status": {
      "active": "Ativa",
      "inactive": "Inativa"
    },
    "pagination": {
      "previous": "Anterior",
      "of": "de",
      "next": "Próximo"
    }
  },
  "en-US": {
    "search": "Search...",
    "no-results": "No results found.",
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "pagination": {
      "previous": "Previous",
      "of": "of",
      "next": "Next"
    }
  }
}
</i18n>

<script>
export default {
  name: 'InteractiveListProduction',
  props: {
    merchant: {
      type: Object
    },
    account: {
      type: Object
    }
  },
  data () {
    return {
      identifier: '',
      page: 1,
      debounceTimer: undefined
    }
  },
  computed: {
    prodAccounts () {
      return this.$store.getters.prodAccounts
    },
    loadingList () {
      return this.$store.getters.loadingListProdAccount
    },
    hasSubscriptionEnabled () {
      return this.$store.getters.hasSubscriptionEnabled
    },
    initialRoute () {
      return this.hasSubscriptionEnabled ? 'OrderType' : 'Items'
    }
  },
  methods: {
    getProdAccounts (merchantId, query = {}) {
      this.$store.dispatch('GET_PROD_ACCOUNTS', { merchantId, query })
    },
    showSearch () {
      if (!Object.entries(this.prodAccounts.items).length) {
        return false
      }
      return (this.prodAccounts.pagination.total_items > 5) || this.identifier
    },
    searchProdAccount (identifier) {
      this.$store.dispatch('UPDATE_LOADING_LIST_PROD_ACCOUNT', true)
      this.page = 1
      const query = { identifier: identifier }
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.getProdAccounts(this.merchant.id, query)
      }, 750)
    },
    goToPage (page) {
      this.$store.dispatch('UPDATE_LOADING_LIST_PROD_ACCOUNT', true)
      this.page = page
      const query = { page: this.page }
      if (this.identifier) { query.identifier = this.identifier }
      this.getProdAccounts(this.merchant.id, query)
    },
    goToAccount (accountId) {
      this.$store.dispatch('toggleGlobalLoading', true)
      this.$store.dispatch('SET_ACCOUNT_ENABLED', null)
      this.$store.dispatch('RESET_PAYMENTS_ENABLED')
      this.$store.dispatch('RESET_PAYMENT_STATE')
      this.$store.dispatch('RESET_ORDER_STATE')
      this.$store.dispatch('RESET_PERMISSION', this.initialRoute)
      this.$router.push({ path: `/${this.merchant.id}/${accountId}/` }).catch(err => err)
      this.$store.dispatch('GET_AUTHORIZATION', { merchant_id: this.merchant.id, account_id: accountId })
    }
  },
  activated () {
    if (!Object.entries(this.prodAccounts.items).length) {
      this.getProdAccounts(this.merchant.id)
    }
  }
}
</script>
